var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tag',{attrs:{"type":_vm.tagclass}},[_vm._v(_vm._s(_vm.tagtext))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }